import { IconInterface } from '../interfaces/icon.interface';

const SimpleOrderCart = (props: IconInterface) => {
	const { color = '#A2A2A2', width = 19, height = 19 } = props;

	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 19 19"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M0.500137 0.5L0.762701 0.588304C2.07104 1.02832 2.72521 1.24832 3.09938 1.7721C3.47355 2.29587 3.47355 2.99159 3.47355 4.38304V7C3.47355 9.82843 3.47355 11.2426 4.34445 12.1213C5.21534 13 6.61702 13 9.42039 13H17.3495"
				stroke={color}
				strokeLinecap="round"
			/>
			<path
				d="M5.95169 15.5C6.77278 15.5 7.4384 16.1716 7.4384 17C7.4384 17.8284 6.77278 18.5 5.95169 18.5C5.1306 18.5 4.46498 17.8284 4.46498 17C4.46498 16.1716 5.1306 15.5 5.95169 15.5Z"
				stroke={color}
			/>
			<path
				d="M14.8716 15.5001C15.6927 15.5001 16.3584 16.1716 16.3584 17.0001C16.3584 17.8285 15.6927 18.5001 14.8716 18.5001C14.0506 18.5001 13.3849 17.8285 13.3849 17.0001C13.3849 16.1716 14.0506 15.5001 14.8716 15.5001Z"
				stroke={color}
			/>
			<path
				d="M3.47279 3.5H14.8217C16.8585 3.5 17.8769 3.5 18.3175 4.17426C18.7582 4.84853 18.357 5.79294 17.5547 7.68176L17.1299 8.68176C16.7554 9.5636 16.5681 10.0045 16.1957 10.2523C15.8233 10.5 15.3479 10.5 14.3969 10.5H3.47279"
				stroke={color}
			/>
		</svg>
	);
};

export default SimpleOrderCart;
